import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  MenuToggleCarmiProps,
  MenuToggleDefinition,
  MenuTogglePlatformProps,
  MenuToggleCSS,
  MenuToggleCarmiCSS,
} from '../MenuToggle.types';
import {
  props as viewerPropsMapper,
  css as viewerCssMapper,
} from './MenuToggle.mapper';

const props = composeMapper<
  PreviewWrapperProps<MenuTogglePlatformProps>,
  MenuToggleDefinition,
  MenuToggleCarmiProps
>()(
  viewerPropsMapper,
  { add: ['compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    return {
      ...viewerProps,
      isOpen: deps.compPreviewState
        ? deps.compPreviewState === 'open'
        : viewerProps.isOpen,
      previewWrapperProps: {
        compPreviewState: deps.compPreviewState,
      },
    };
  },
);

type MenuTogglePreviewStyles = MenuToggleCSS & { zIndex?: string };

const css = composeMapper<
  MenuTogglePreviewStyles,
  MenuToggleDefinition,
  MenuToggleCarmiCSS
>()(
  viewerCssMapper,
  { add: ['shouldResetTinyMenuZIndex'] },
  (resolver, dependencies, carmiData) => {
    const viewerCss = resolver(dependencies, carmiData);
    const { shouldResetTinyMenuZIndex } = dependencies;
    const styles: MenuTogglePreviewStyles = {};
    if (shouldResetTinyMenuZIndex) {
      styles.zIndex = 'auto';
    }

    return { ...styles, ...viewerCss };
  },
);

export default createComponentPreviewMapperModel({
  props,
  css,
});
